export const MAP_UPDATE_GEOLOCATION = 'MAP_UPDATE_GEOLOCATION';

export const setLocation = (value) => ({
  type: MAP_UPDATE_GEOLOCATION,
  payload: value,
});

export const setGeoLocation = (value) => {
  return setLocation(value);
};
